import React from "react";
import { Modal, Button } from "antd";

// SVG tomato shape
const TomatoIcon = ({ color }) => (
  <svg width="100%" height="100%" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" style={{ maxWidth: '60px', maxHeight: '60px' }}>
    {/* Stem */}
    <path d="M50 10 L50 25 C50 25, 55 20, 60 25" stroke="green" strokeWidth="4" fill="none" />
    {/* Tomato body */}
    <circle cx="50" cy="55" r="30" fill={color} />
    {/* Highlight */}
    <circle cx="40" cy="45" r="5" fill="white" fillOpacity="0.3" />
    {/* Shadow overlay to give depth */}
    <circle cx="50" cy="55" r="30" fill="black" fillOpacity="0.1" />
  </svg>
);

// Render ripeness chart for each variety
const RipenessVarietyChart = ({ varietyName, ripenessData = [] }) => {
  // Sort by label in descending order (convert to number if possible)
  const sortedData = [...ripenessData].sort((a, b) => {
    const labelA = isNaN(Number(a.label)) ? a.label : Number(a.label);
    const labelB = isNaN(Number(b.label)) ? b.label : Number(b.label);
    return labelB - labelA;
  });
  
  return (
    <div className="mb-6" key={`ripeness-${varietyName}`}>
      <h3 className="font-semibold mb-2 text-primaryBlue">{varietyName}</h3>
      <div className="flex flex-row flex-wrap gap-4 justify-around">
        {sortedData.map((item, index) => (
          <div key={`${varietyName}-ripeness-${index}`} className="flex flex-col items-center" style={{ minWidth: '30px', maxWidth: '60px' }}>
            <div className="mb-1" style={{ width: '100%', height: 'auto' }}>
              <TomatoIcon color={item.color} />
            </div>
            <span className="text-xs">{item.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

// Main Ripeness Chart Modal Component
const RipenessChart = ({ 
  isOpen, 
  onClose, 
  siteMetadata, 
  varietyData 
}) => {
  // Get all variety names from varietyData
  const allVarieties = varietyData.map(variety => variety.name);
  
  return (
    <Modal
      title="Tomato Ripeness Chart"
      open={isOpen}
      onCancel={onClose}
      footer={null}
      centered={true}
      width="auto"
      style={{ 
        maxWidth: '850px',
        margin: '0 auto',
        top:"-20%"

      }}
      bodyStyle={{
        padding: '16px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}
    >
      <div className="w-full">
        {allVarieties.length > 0 ? (
          allVarieties.map(varietyName => (
            <RipenessVarietyChart 
              key={varietyName} 
              varietyName={varietyName} 
              ripenessData={siteMetadata?.ripeness_chart?.[varietyName] || []} 
            />
          ))
        ) : (
          <p>No variety data available</p>
        )}
      </div>
    </Modal>
  );
};

export default RipenessChart;
